<mat-accordion>
  <mat-expansion-panel class="mat-elevation-z0">

    <mat-expansion-panel-header class="panel-header">
      <mat-panel-title>
        <div fxLayout="column">
          <div>{{ entries[0].interestRate | number:'1.2-2' }}%<span *ngIf="entries[0].changeReason"> &ndash; {{ InterestRateChangeReasonLabel.get(entries[0].changeReason) }}</span></div>
          <div class="mat-caption panel-date">{{ entries[0].effectiveDateUtc | date:'medium' }}</div>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div fxLayout="column" class="expanded-list" fxLayoutGap="34px">
      <ng-container *ngFor="let entry of entries; let i = index">
        <div *ngIf="i > 0" fxLayout="column">
          <div>{{ entry.interestRate | number:'1.2-2' }}%<span *ngIf="entry.changeReason"> &ndash; {{ InterestRateChangeReasonLabel.get(entry.changeReason) }}</span></div>
          <div class="mat-caption panel-date">{{ entry.effectiveDateUtc | date:'medium' }}</div>
        </div>
      </ng-container>
    </div>

  </mat-expansion-panel>
</mat-accordion>
